<template>
  <div class="content-block" ref="footer">
    <footer class="footer">
      Powered by Remote.io (v {{ version }}) ; Copyright © 2022-{{new Date().getFullYear()}} ; All rights reserved.
    </footer>
  </div>
</template>


<script>


export default {
  data() {
    return {
      version: "",
    };
  },
  created(){
    this.version = this.$store.getters["config/getAppVersion"]
  }
}
</script>

<style lang="scss">
@use "sass:color";
@use "@/themes/vars" as *;

.footer {
  display: block;
  color: rgba($base-text-color, color.alpha($base-text-color) * 0.7);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 0px;
  // padding-top: 20px;
  padding-bottom: 5px;
  // padding-bottom: 24px;
  font-size:12px;
}
</style>
